import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ticket-calculator"
export default class extends Controller {
    static targets = ["type", "price", "quantity", "total"]
    static values = {
        gratuitPrice: { type: Number, default: 0.0 },
        t2Price: { type: Number, default: 5.0 },
        t10Price: { type: Number, default: 10.0 }
    }

    connect() {
        console.log("Ticket calculator controller connected")
        // Initialiser immédiatement au chargement
        this.updatePriceAndTotal()
    }

    // Prix par type de ticket
    get prices() {
        return {
            'gratuit': this.gratuitPriceValue,
            't2': this.t2PriceValue,
            't10': this.t10PriceValue
        }
    }

    // Méthode appelée quand le type change
    typeChanged() {
        this.updatePriceAndTotal()
    }

    // Méthode appelée quand la quantité change
    quantityChanged() {
        this.updateTotal()
    }

    // Met à jour le prix basé sur le type sélectionné
    updatePriceAndTotal() {
        const selectedType = this.typeTarget.value
        console.log("Type sélectionné:", selectedType)

        if (selectedType && this.prices[selectedType] !== undefined) {
            const calculatedPrice = this.prices[selectedType]
            this.priceTarget.value = calculatedPrice.toFixed(2)
            console.log("Prix mis à jour:", calculatedPrice)
        }

        this.updateTotal()
    }

    // Calcule et affiche le total
    updateTotal() {
        const price = parseFloat(this.priceTarget.value) || 0
        const quantity = parseInt(this.quantityTarget.value) || 1
        const total = price * quantity

        console.log("Calcul - Prix:", price, "Quantité:", quantity, "Total:", total)

        const formattedTotal = total.toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' €'

        this.totalTarget.textContent = formattedTotal
        console.log("Total affiché:", formattedTotal)
    }
}